export default __webpack_public_path__ + "static/media/ppoSlider1.32728ee4.png";